import React, { useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import Swal from "sweetalert2";
import { importClientsData, importViabilitiesStudy } from "../gestionCarteraApi";
import { COLORS, ModalShell, PrimaryButton, SecondaryButton } from "../gestionCarteraUi";

const UPLOADS = [
  {
    key: "clients",
    label: "Actualizar datos de clientes",
    send: importClientsData,
    success: "Se cargó exitosamente la información de los clientes.",
  },
  {
    key: "viabilities",
    label: "Estudios de viabilidad",
    send: importViabilitiesStudy,
    success: "Se cargó exitosamente la información de las viabilidades.",
  },
];

/** Importadores del antiguo módulo Clientes (mismos endpoints). */
export default function ImportarClientesModal({ open, onClose }) {
  const [files, setFiles] = useState({});
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    if (loading) return;
    setFiles({});
    onClose();
  };

  const handleSubmit = async () => {
    setLoading(true);
    const selected = UPLOADS.filter((upload) => files[upload.key]);
    const results = await Promise.allSettled(selected.map((upload) => upload.send(files[upload.key])));
    setLoading(false);

    const failed = selected.filter((_, index) => results[index].status === "rejected");
    if (failed.length === 0) {
      handleClose();
      Swal.fire({
        icon: "success",
        title: "Importación exitosa",
        text: selected.map((upload) => upload.success).join(" "),
        confirmButtonColor: COLORS.primary,
      });
      return;
    }
    Swal.fire({
      icon: "error",
      title: "Error",
      text: `No se pudo cargar: ${failed.map((upload) => upload.label).join(", ")}. Verifica el archivo y vuelve a intentarlo.`,
      confirmButtonColor: COLORS.primary,
    });
  };

  return (
    <ModalShell
      open={open}
      onClose={handleClose}
      title="Importar clientes"
      subtitle="Selecciona uno o ambos archivos CSV."
      actions={
        <>
          <SecondaryButton onClick={handleClose}>Cancelar</SecondaryButton>
          <PrimaryButton
            disabled={loading || !Object.values(files).some(Boolean)}
            onClick={handleSubmit}
            startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
          >
            Cargar
          </PrimaryButton>
        </>
      }
    >
      {UPLOADS.map((upload) => (
        <Box key={upload.key} sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography sx={{ fontWeight: 500 }}>{upload.label}</Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
            <SecondaryButton component="label">
              Seleccionar archivo
              <input
                type="file"
                accept=".csv"
                hidden
                onChange={(event) =>
                  setFiles((current) => ({ ...current, [upload.key]: event.target.files?.[0] || null }))
                }
              />
            </SecondaryButton>
            <Typography sx={{ color: COLORS.muted }}>
              {files[upload.key]?.name || "Ningún archivo seleccionado"}
            </Typography>
          </Box>
        </Box>
      ))}
    </ModalShell>
  );
}
